
const state = () => ({})

const getters = {
  business: state => prop => null,
  ticketInfo: state => null,
  invoiceInfo: state => null,
  fiscalInfo: state => null,
  fiscalData: state => null,
  orderMaxAmount: state => 3000, // REV-18237
  contentPrice: state => payload => null,
  shouldAddReason: state => null,
  shouldSignInvoice: state => null,
}

const mutations = {}

const actions = {
  printPreHeader ({}, { order, invoice }) {},
  printAdditionalHeader ({}, business) {},
  printAdditionalFooter ({}, business) {},
  printCheckSummary ({ rootGetters }, order) {
    AndroidPrinter.text2(rootGetters['translate']('sum'), Number(order.sum || 0).toFixed(2))
    if (Number(order.discountAmount || 0).notEqualTo(0)) {
      AndroidPrinter.text2(rootGetters['translate']('discount'), Number(order.discountAmount || 0).toFixed(2))
    }
    AndroidPrinter.text2(rootGetters['translate']('subtotal'), Number(order.subtotal || 0).toFixed(2))
    AndroidPrinter.text2(rootGetters['translate']('tax'), Number(order.taxAmount || 0).toFixed(2))
    AndroidPrinter.text2(rootGetters['translate']('total'), Number(order.total || 0).toFixed(2), JSON.stringify({
      size: 'large',
    }))
  },
  printInvoiceSummary ({ rootState, rootGetters }, { order, invoice }) {
    AndroidPrinter.text2(rootGetters['translate']('sum'), invoice.sum.toFixed(2))
    if (invoice.discountAmount.notEqualTo(0)) {
      AndroidPrinter.text2(rootGetters['translate']('discount'), invoice.discountAmount.toFixed(2))
    }
    AndroidPrinter.text2(rootGetters['translate']('subtotal'), invoice.subtotal.toFixed(2))
    invoice.appliedTaxes.forEach(appliedTax => {
      const taxName = rootState.rummage.data.Tax?.find(o => o.percentage == appliedTax.tax_percentage)?.name ?? `${parseFloat(appliedTax.tax_percentage).toFixed(1)}%`
      AndroidPrinter.text3(
        `${taxName} (${appliedTax.base_amount.toFixed(2)})`,
        appliedTax.tax_amount.toFixed(2),
        (appliedTax.base_amount + appliedTax.tax_amount).toFixed(2)
      )
    })
    AndroidPrinter.text2(rootGetters['translate']('total'), invoice.total.toFixed(2), JSON.stringify({ size: 'large' }))
  },
  signPrintCheck ({}, { order, reason }) {},
  signInvoice ({}, invoice) {},
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
